import Input from '@components/input/Input';
import Label from '@components/inputWithFormItem/Label';
import styles from '@components/inputWithFormItem/_InputWithFormItem.module.scss';
import { Form as AntDesignForm } from 'antd';
import { FormItemProps } from 'antd/es/form/FormItem';
import React, { useMemo, useState } from 'react';

type InputWithFormItemProps = {
  label?: string;
  LabelIcon?: React.ElementType;
  PrefixIcon?: React.ElementType;
  onChange?: (value: string | null | number) => void;
  helperText?: string;
  placeholderText?: string;
  disabled?: boolean;
  inputClassName?: string;
  value?: string;
  type?: 'default' | 'number' | 'textArea' | 'password';
  inputName: string;
  rules?: object[];
  formItemProps?: FormItemProps;
  dynamicHelperText?: boolean;
  required?: boolean;
  size?: 'small' | 'middle' | 'large';
  rows?: number;
  errorMessage?: string;
  noStyle?: boolean;
  precision?: number;
};

const InputWithFormItem: React.FC<InputWithFormItemProps> = ({
  inputName,
  PrefixIcon,
  onChange,
  placeholderText,
  disabled,
  value = undefined,
  type = 'default',
  label,
  rules,
  LabelIcon,
  formItemProps = {
    colon: false,
  },
  helperText,
  dynamicHelperText,
  required = false,
  size = 'middle',
  rows = 6,
  errorMessage = '',
  noStyle = false,
  precision,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const showHelperText = useMemo(
    () => !!helperText && (!dynamicHelperText || isFocused),
    [dynamicHelperText, helperText, isFocused],
  );

  const errorMessageProps = useMemo(
    () => (errorMessage ? { help: errorMessage, validateStatus: 'error' } : {}),

    [errorMessage],
  );

  return (
    <AntDesignForm.Item
      name={inputName}
      rules={rules}
      label={label && <Label label={label} LabelIcon={LabelIcon} />}
      extra={showHelperText ? helperText : undefined}
      className={styles.formItem}
      // @ts-ignore
      onBlur={() => setIsFocused(false)}
      onFocus={() => setIsFocused(true)}
      size={size}
      required={required}
      {...formItemProps}
      {...errorMessageProps}
      noStyle={noStyle}
    >
      <Input
        PrefixIcon={PrefixIcon}
        onChange={onChange}
        placeholderText={placeholderText}
        disabled={disabled}
        value={value}
        type={type}
        size={size}
        rows={rows}
        precision={precision}
      />
    </AntDesignForm.Item>
  );
};

export default InputWithFormItem;
